import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "my-section" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "my-title uppercase" }, " Lista dei clienti ", -1)
const _hoisted_4 = { class: "my-title" }
const _hoisted_5 = { class: "my-buttons my-card--body" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Aggiorna Dati ")
const _hoisted_7 = { class: "container my-10 px-12" }
const _hoisted_8 = {
  id: "lista-tabella",
  class: "justify-center container my-10 w-full"
}
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"row flex md:grid grid-cols-1 gap-1 md:grid-cols-12\"><div class=\"riga13 col-span-4 text-center font-bold\">Nome</div><div class=\"riga13 col-span-4 text-center font-bold\">Cognome</div><div class=\"col-span-2 d-lg-block d-none text-center font-bold\"> Data ultimo trattamento</div><div class=\"riga13 col-span-2 text-center font-bold\">Vedi</div></div>", 1)
const _hoisted_10 = { class: "riga13 col-span-4 text-center capitalize" }
const _hoisted_11 = { class: "riga13 col-span-4 text-center capitalize" }
const _hoisted_12 = { class: "d-lg-block d-none col-span-2 text-center" }
const _hoisted_13 = { class: "riga13 col-span-2 text-center" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Apri ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, " (macchina " + _toDisplayString(_ctx.$route.params.machineId) + ") ", 1),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Button, {
          class: "is-secondary",
          icon: "fas fa-sync",
          onClick: _ctx.refreshPage
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listaClienti, (cliente, cRow) => {
            return (_openBlock(), _createElementBlock("div", {
              key: cRow,
              class: "row flex md:grid grid-cols-1 gap-1 md:grid-cols-12"
            }, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.get(cliente, 'nome', '')), 1),
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.get(cliente, 'cognome', '')), 1),
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.get(cliente, 'dataUltimoTrattamento', '')), 1),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'Customer',
                  params: { machineId: _ctx.$route.params.machineId, customerId: cliente.idCliente } }
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}